import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { mountRootParcel } from 'single-spa';

import { styled } from 'netline-ui';
import services from 'services';
import Parcel from 'view/components/ApplicationModule/Parcel';
import LoadingProgress from 'view/components/LoadingProgress/LoadingProgress';

import styles, { preloginViewClasses } from './PreloginView.styles';

const PreloginViewRoot = styled(Parcel, { name: preloginViewClasses.$name })(styles);

const PreloginView = () => {
  const { t } = useTranslation();

  const [preloginWidget, setPreloginWidget] = useState<string | null>(services.appFrame.prelogin.getWidget);
  useEffect(() => {
    return services.appFrame.prelogin.onWidgetChange((widget) => {
      setPreloginWidget(widget);
    });
  }, []);

  const preloginWidgetConfig = (preloginWidget && services.getWidget(preloginWidget)) || null;

  if (!preloginWidgetConfig) {
    return <LoadingProgress>{t('progress.initializing_plugins')}</LoadingProgress>;
  }

  return (
    <PreloginViewRoot
      className={preloginViewClasses.root}
      config={preloginWidgetConfig}
      services={services}
      mountParcel={mountRootParcel}
    />
  );
};

export default PreloginView;
